export default {
    bigIcon:    'bigIcon',
    redRounded: 'redRounded',
};